/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

const url: string = window.location.href;

/* 
mmusterperson2@wbsedu.de
KreisHaft868

*/
const uris: {
  prod: string;
  dev: string;
} = {
  prod: "https://lernzeitkonto.wbstraining.de",
  dev: "http://localhost:3000",
};

export const msalConfig = {
  auth: {
    clientId: "ff329a20-099f-4ae6-a8c8-c34d32ca2168", // This is the ONLY mandatory field that you need to supply.
    authority:
      "https://login.microsoftonline.com/e488d80e-8ba4-48e8-844f-db1bb7004432", // Defaults to "https://login.microsoftonline.com/common"
    redirectUri: url.includes("localhost") ? uris.dev : uris.prod,
    postLogoutRedirectUri: "/",
    clientCapabilities: ["CP1"], // this lets the resource owner know that this client is capable of handling claims challenge.
  },
  cache: {
    cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      /**
       * Below you can configure MSAL.js logs. For more information, visit:
       * https://docs.microsoft.com/azure/active-directory/develop/msal-logging-js
       */
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;

          case LogLevel.Info:
            console.info(message);
            return;

          case LogLevel.Verbose:
            console.debug(message);
            return;

          case LogLevel.Warning:
            console.warn(message);
            return;

          default:
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ["User.Read"]
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
